import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M20.002 10C20.002 15.5228 15.5248 20 10.002 20C4.47911 20 0.00195312 15.5228 0.00195312 10C0.00195312 4.47715 4.47911 0 10.002 0C15.5248 0 20.002 4.47715 20.002 10ZM2.50195 10C2.50195 14.1421 5.85982 17.5 10.002 17.5C14.1441 17.5 17.502 14.1421 17.502 10C17.502 5.85786 14.1441 2.5 10.002 2.5C5.85982 2.5 2.50195 5.85786 2.50195 10Z",
      fill: "#EDEDED"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.99805 0C11.7357 0 13.4433 0.452769 14.9526 1.31368C16.462 2.1746 17.7209 3.41395 18.6055 4.90959C19.49 6.40522 19.9695 8.10553 19.9968 9.84293C20.0241 11.5803 19.5982 13.2949 18.7611 14.8175L16.5703 13.6132C17.1982 12.4711 17.5176 11.1852 17.4971 9.88219C17.4767 8.57914 17.117 7.30392 16.4536 6.18219C15.7902 5.06046 14.846 4.13095 13.714 3.48526C12.582 2.83958 11.3013 2.5 9.99805 2.5L9.99805 0Z",
      fill: "#489ffa"
    }, null, -1)
  ])))
}
export default { render: render }